import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ilustrations/sobre.gif'


const _withScopeId = n => (_pushScopeId("data-v-a3d32f88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "256",
  width: "256"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Sobre este projeto"),
  /*#__PURE__*/_createElementVNode("p", null, "Este projeto de lista de compras foi desenvolvido inteiramente por André Moura Santos, como forma de demonstrar as capacidades de criação de ferramentas úteis, intuitivas e visualmente atraentes.")
], -1))
const _hoisted_3 = { id: "externalLinks" }
const _hoisted_4 = {
  href: "https://github.com/andremourasantos/lista-de-compras",
  rel: "external",
  target: "_blank"
}
const _hoisted_5 = {
  href: "https://www.linkedin.com/in/andremourasantos/",
  rel: "external",
  target: "_blank"
}
const _hoisted_6 = {
  href: "https://andremourasantos.com.br/",
  rel: "external",
  target: "_blank"
}
const _hoisted_7 = { id: "info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Versão de Nov./23", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhArrowSquareOut = _resolveComponent("PhArrowSquareOut")!
  const _component_PhInfo = _resolveComponent("PhInfo")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, [
        _createVNode(_component_PhArrowSquareOut, {
          size: 29,
          color: "#333333",
          weight: "light"
        }),
        _createTextVNode(" Acessar GitHub ")
      ]),
      _createElementVNode("a", _hoisted_5, [
        _createVNode(_component_PhArrowSquareOut, {
          size: 29,
          color: "#333333",
          weight: "light"
        }),
        _createTextVNode(" Acessar LinkedIn ")
      ]),
      _createElementVNode("a", _hoisted_6, [
        _createVNode(_component_PhArrowSquareOut, {
          size: 29,
          color: "#333333",
          weight: "light"
        }),
        _createTextVNode(" Site de André Moura Santos ")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_PhInfo, {
        size: 29,
        color: "#333333",
        weight: "light"
      }),
      _hoisted_8
    ])
  ]))
}